import { graphql } from 'gatsby';
import ComponentApi from 'src/components/ComponentApi';
import CodeView from 'src/components/CodeView';
import horizontalMultiSteps from 'src/examples/MultiSteps/horizontal';
import verticalMultiSteps from 'src/examples/MultiSteps/vertical';
import whiteMultiSteps from 'src/examples/MultiSteps/white';
import primaryMultiSteps from 'src/examples/MultiSteps/primary';
import accentMultiSteps from 'src/examples/MultiSteps/accent';
import warningMultiSteps from 'src/examples/MultiSteps/warning';
import positiveMultiSteps from 'src/examples/MultiSteps/positive';
import negativeMultiSteps from 'src/examples/MultiSteps/negative';
import * as React from 'react';
export default {
  graphql,
  ComponentApi,
  CodeView,
  horizontalMultiSteps,
  verticalMultiSteps,
  whiteMultiSteps,
  primaryMultiSteps,
  accentMultiSteps,
  warningMultiSteps,
  positiveMultiSteps,
  negativeMultiSteps,
  React
};